<div
  #layoutTopbar
  [style.display]="isVisible ? 'liline-block' : 'none'"
  class="layout-topbar"
  [ngClass]="{ 'at-log-in': !!isAtLogin }"
>
  <div class="p-d-flex p-ai-center">
    <a
      *ngIf="!isAtLogin"
      class="topbar-icon-button icon-menu"
      (click)="toggleSideMenu()"
    ></a>
    <img
      class="only-for-desktop"
      [src]="
        isAtLogin
          ? './assets/images/header-logo-holding.svg'
          : './assets/images/header-logo.png'
      "
      alt="logo"
      [srcset]="
        isAtLogin
          ? './assets/images/header-logo-holding.svg'
          : './assets/images/header-logo@2x.png 2x, ./assets/images/header-logo@3x.png 3x'
      "
      [style.cursor]="isAtLogin ? 'default' : 'pointer'"
      (click)="isAtLogin ? null : goHome()"
    />
  </div>
  <div class="mobile-logo-container">
    <img
      [src]="
        isAtLogin
          ? './assets/images/header-logo-holding.svg'
          : './assets/images/header-logo.png'
      "
      alt="logo"
      [srcset]="
        isAtLogin
          ? './assets/images/header-logo-holding.svg'
          : './assets/images/header-logo@2x.png 2x, ./assets/images/header-logo@3x.png 3x'
      "
      [style.cursor]="isAtLogin ? 'default' : 'pointer'"
      (click)="isAtLogin ? null : goHome()"
    />
  </div>
  <div *ngIf="!isAtLogin" class="p-d-flex p-ai-center">
    <ng-template [ngIf]="newsInfo">
      <a
        *ngIf="newsInfo.notReadCount === 0"
        class="topbar-icon-button icon-notice"
        (click)="
          notificationPanel.toggle($event); updateToDo(); updateNotification()
        "
      ></a>
      <a
        *ngIf="newsInfo.notReadCount > 0"
        class="topbar-icon-button icon-notice"
        pBadge
        [value]="newsInfo ? newsInfo.notReadCount.toString() : '0'"
        (click)="
          notificationPanel.toggle($event); updateToDo(); updateNotification()
        "
      ></a>
    </ng-template>

    <button
      pButton
      type="button"
      [label]="currentLanguageLabel"
      icon="pi pi-angle-down"
      iconPos="right"
      (click)="langPanel.toggle($event)"
      class="only-for-desktop"
    ></button>
    <div class="topbar-horizontal-divider only-for-desktop"></div>
    <button
      type="button"
      class="p-button p-component only-for-desktop"
      (click)="userInfoPanel.toggle($event)"
    >
      <span>{{ currentUser?.userName }}</span>
      <p-avatar image="./assets/images/ic-person.png" shape="circle"></p-avatar>
    </button>
  </div>
</div>

<p-overlayPanel #notificationPanel [appendTo]="layoutTopbar">
  <div
    class="list topbar-list"
    *ngIf="newsInfo"
    style="height: 260px; overflow: scroll"
  >
    <ng-template ngFor let-info [ngForOf]="newsInfo.news">
      <div
        class="list-item notification"
        [ngClass]="info.notRead ? 'page-title p-text-bold' : ''"
      >
        <div class="p-d-flex p-jc-between">
          <a
            href="javascript:;"
            (click)="navigateTodo(info); notificationPanel.hide()"
          >
            <p-tag [styleClass]="info.notRead ? 'tag p-text-bold' : 'tag'"
              >{{
                info.caseStatus
                  | caseStatusPipe
                    : { useRole: currentUser?.extranetUserRole, type: "Notice" }
                  | translate
              }}
            </p-tag>
          </a>
          <div>
            {{ info.createDate | date : appConfig.format.date + " HH:mm" }}
          </div>
        </div>
        <span class="description">
          {{
            info.description
              | newsDescriptionPipe
                : {
                    caseStatus: info.caseStatus,
                    replace: info.replace,
                    formatDate: appConfig.format.date
                  }
          }}
        </span>
      </div>
    </ng-template>
  </div>
  <button
    pButton
    type="button"
    label="More"
    class="w-100 p-button-outlined p-button-rounded"
    (click)="navigateDetail(); notificationPanel.hide(); updateToDo()"
  ></button>
</p-overlayPanel>

<p-overlayPanel #commonPanel [appendTo]="layoutTopbar">
  <div class="list topbar-list">
    <div class="list-item">
      collect 01
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 02
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 03
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 04
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 05
      <a href="#" class="list-item-link">移除</a>
    </div>
  </div>
  <button pButton type="button" label="Add" class="w-100"></button>
</p-overlayPanel>

<p-overlayPanel #langPanel [appendTo]="layoutTopbar">
  <div class="list topbar-list">
    <div class="list-item" *ngFor="let languageOption of languageOptions">
      <a
        href="#"
        (click)="changeLanguage($event, languageOption); langPanel.hide()"
      >
        {{ languageOption.label }}
      </a>
    </div>
  </div>
</p-overlayPanel>

<p-overlayPanel #userInfoPanel [appendTo]="layoutTopbar">
  <div class="topbar-userinfo">
    <ng-container [ngSwitch]="currentUser?.extranetUserRole">
      <ng-template [ngSwitchCase]="0">
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.No" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ currentUser?.userNo }}</div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">
            {{ "UserInfo.SalesName" | translate }}
          </div>
          <div class="p-col-8 p-p-0">{{ currentUser?.userName }}</div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Dept" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ currentUser?.departmentName }}</div>
        </div>
      </ng-template>
      <ng-template [ngSwitchCase]="1">
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Name" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ currentUser?.userName }}</div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Dept" | translate }}</div>
          <div class="p-col-8 p-p-0">
            {{
              (currentUser?.dealerCode || "") +
                " " +
                (currentUser?.dealerName || "")
            }}
          </div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Email" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ currentUser?.email }}</div>
        </div>
      </ng-template>
      <ng-template [ngSwitchCase]="2">
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Name" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ currentUser?.userName }}</div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Dept" | translate }}</div>
          <div class="p-col-8 p-p-0">
            {{
              (currentUser?.agentCode || "") +
                " " +
                (currentUser?.agentName || "")
            }}
          </div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Email" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ currentUser?.email }}</div>
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="!isAzureADEnable || isExtranet">
      <p-divider></p-divider>
      <div
        *ngIf="
          currentUser?.extranetUserRole === 1 ||
          currentUser?.extranetUserRole === 2
        "
        class="topbar-userinfo-link"
      >
        <a href="javascript:void(0)" (click)="goChangePassword()">
          {{ "Login.ChangePassword" | translate }}
        </a>
      </div>
      <button
        pButton
        type="button"
        label="Log Out"
        (click)="logout()"
        class="w-100"
      ></button>
    </ng-container>
  </div>
</p-overlayPanel>
